import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace ABIConformation {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    // Helper function to check if an element/level is available in the show
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options
      
      return show.show_elements.some(se => 
        se.show_element === elementOrLevel || se.level === elementOrLevel
      );
    };

    // Helper function to check if the show has regular "Conformation" level
    const hasRegularConformation = show?.show_elements?.some(se => 
      se.level === "Conformation"
    );

    // All possible ABI conformation options
    // Regular conformation classes (shown when level="Conformation" exists)
    const regularConformationClasses = [
      { value: Constants.dog_class_element_level.abi_6_9_months, id: Constants.dog_class_element_level.abi_6_9_months },
      { value: Constants.dog_class_element_level.abi_9_12_months, id: Constants.dog_class_element_level.abi_9_12_months },
      { value: Constants.dog_class_element_level.abi_12_18_months, id: Constants.dog_class_element_level.abi_12_18_months },
      { value: Constants.dog_class_element_level.abi_bred_by_exibitor, id: Constants.dog_class_element_level.abi_bred_by_exibitor },
      { value: Constants.dog_class_element_level.abi_open, id: Constants.dog_class_element_level.abi_open },
      //{ value: Constants.dog_class_element_level.abi_best_of_breed, id: Constants.dog_class_element_level.abi_best_of_breed },
      { value: Constants.dog_class_element_level.abi_jr_champion, id: Constants.dog_class_element_level.abi_jr_champion },
      { value: Constants.dog_class_element_level.abi_champion, id: Constants.dog_class_element_level.abi_champion },
      { value: Constants.dog_class_element_level.abi_master_champion, id: Constants.dog_class_element_level.abi_master_champion },
      { value: Constants.dog_class_element_level.abi_grand_champion, id: Constants.dog_class_element_level.abi_grand_champion },
      { value: Constants.dog_class_element_level.abi_supreme_champion, id: Constants.dog_class_element_level.abi_supreme_champion },
      { value: Constants.dog_class_element_level.abi_ultimate_champion, id: Constants.dog_class_element_level.abi_ultimate_champion },
      { value: Constants.dog_class_element_level.abi_royal_champion, id: Constants.dog_class_element_level.abi_royal_champion },
      { value: Constants.dog_class_element_level.abi_legendary_champion, id: Constants.dog_class_element_level.abi_legendary_champion }
    ];

    // Other special classes (shown based on specific show elements)
    const specialClasses = [
      { value: Constants.dog_class_element.conformation_altered, id: Constants.dog_class_element.conformation_altered },
      { value: Constants.dog_class_element_level.abi_baby_puppy, id: Constants.dog_class_element_level.abi_baby_puppy },
      { value: Constants.dog_class_element.veteran, id: Constants.dog_class_element.veteran },
      { value: Constants.dog_class_element.brace, id: Constants.dog_class_element.brace },
      { value: Constants.dog_class_element.abi_stud_dog, id: Constants.dog_class_element.abi_stud_dog },
      { value: Constants.dog_class_element.abi_brood_bitch, id: Constants.dog_class_element.abi_brood_bitch },
      { value: Constants.dog_class_element.abi_star, id: Constants.dog_class_element.abi_star },
      { value: Constants.dog_class_element.abi_canadian_bred_bis, id: Constants.dog_class_element.abi_canadian_bred_bis },
      { value: Constants.dog_class_element.abi_bred_by_bis, id: Constants.dog_class_element.abi_bred_by_bis },
      { value: Constants.dog_class_element.abi_show_of_shows, id: Constants.dog_class_element.abi_show_of_shows }
    ];

    // Build the full list of options
    const conformationOptions = [
      // Include all regular conformation classes if "Conformation" level exists
      ...(hasRegularConformation ? regularConformationClasses : []),
      // Then filter special classes based on availability
      ...specialClasses.filter(option => isElementAvailable(option.value))
    ];

    // Only return the form if there are available options
    if (conformationOptions.length === 0) {
      return [];
    }

    return [{
      allowDuplicates: false,
      inputs: [{
        type: "checkbox", 
        label: Constants.dog_class_element.conformation, 
        multiSelect: true, 
        options: conformationOptions
      }]
    }];
  };

  // Keep the old static form for backward compatibility
  export const form: IEventRegisterRow[] = getForm();
}